import Utils from 'core-helpers/utils.js';
import DiscountService from 'discount/discount-service.js';
import SharedDataService from 'data/shared-data-service.js';
import DiscountVoucherUI from 'forms/discount-voucher-class.js';
import {storeEcommerceOriginValue} from '@busuu/marketing';

/**
 * The discount form request a discount value
 * to the Backend using the plans API.
 * If success, we store the discount and redirect
 * the user to the /n/plans page (/premium).
 * It's different from the voucher form where
 * it actually make a user premium straight after it.
 */

const discountForm = Utils.getById('discountForm');
const discountInput = Utils.getById('discountInput');
let discountUI = null;

/**
 * XHR
 */
const onSuccess = (response) => {
    SharedDataService.storeDiscountCoupon(response.coupon);
    storeEcommerceOriginValue('DISCOUNT_COUPON_FORM');
    window.location.href = discountForm.getAttribute('action');
};

const onError = (error = {}) => {
    let trs = null;
    switch (error.type) {
        case 'COUPON_MISSING':
            trs = 'FIELD_REQUIRED';
            break;
        case 'COUPON_API_RESPONSE_MALFORMED':
        case 'COUPON_UNAVAILABLE_OR_NOT_FOUND':
        case 'COUPON_API_CALL_FAILED':
        default:
            trs = 'NOT_VALID_DISCOUNT_CODE';
            break;
    }
    discountUI.showErrorAndEnableForm(trs);
};

const onRequestStart = () => {
    discountUI.hideErrorsAndDisableForm();
};

const onFormSubmit = (e) => {
    e.preventDefault();
    onRequestStart();
    DiscountService.getCouponValidity(discountInput.value).then(onSuccess).catch(onError);
};

const init = () => {
    if (!discountForm) {
        return false;
    }

    discountUI = new DiscountVoucherUI(Utils.getById('discountSubmit'), Utils.getById('discountError'));
    discountForm.addEventListener('submit', onFormSubmit);
};

init();
